/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['zappos', '\36', 'versional'] }] */
import React from 'react';
import cn from 'classnames';

import SephoraLogo from 'images/sephora-logo-black.svg';
import SixpmLogo from 'images/6pm/logo-black.svg';
import VrsnlLogo from 'images/vrsnl-zappos/logo-black.svg';
import ZapposLogo from 'images/zappos/logo-black.svg';
import useMartyContext from 'hooks/useMartyContext';
import { MERCHANTID_MARKET_NAME_MAPPING } from 'helpers/MarketplaceUtils';
import { isVendorSephora } from 'helpers/ProductUtils';

// eslint-disable-next-line css-modules/no-unused-class
import css from 'styles/components/cart/itemMerchantLogo.scss';

const marketNameLogoMap = {
  'zappos': ZapposLogo,
  '6pm': SixpmLogo,
  'versional': VrsnlLogo
} as const;

export interface ItemMerchantLogoProps {
  className?: string;
  merchantId: string;
  vendorCode?: string;
}

export const ItemMerchantLogo = ({ className, merchantId, vendorCode }: ItemMerchantLogoProps) => {
  const {
    testId,
    marketplace: { dataMaskPiiElements }
  } = useMartyContext();

  if (isVendorSephora(vendorCode)) {
    return (
      <p className={cn(className, css.container)} data-cs-mask={dataMaskPiiElements}>
        <img className={css.sephora} src={SephoraLogo} alt="Sephora" data-test-id={testId('merchantLogo')} />
      </p>
    );
  }

  const marketName: string | undefined = MERCHANTID_MARKET_NAME_MAPPING[merchantId as keyof typeof MERCHANTID_MARKET_NAME_MAPPING];

  if (!marketName) {
    return null;
  }

  return (
    <p className={cn(className, css.container)} data-cs-mask={dataMaskPiiElements}>
      <img
        alt={marketName}
        className={css[marketName]}
        data-test-id={testId('merchantLogo')}
        src={marketNameLogoMap[marketName as keyof typeof marketNameLogoMap]}
      />
    </p>
  );
};

export default ItemMerchantLogo;
